export const ActionTypes = {
    FETCH_USER: "FETCH_USER",
    UPDATE_USER: "UPDATE_USER",
    ADD_USER_FOLLOWER: "ADD_USER_FOLLOWER",
    REMOVE_USER_FOLLOWER: "REMOVE_USER_FOLLOWER",
    INCREMENT_USER_FEED_COUNT: "INCREMENT_USER_FEED_COUNT",
    DECREMENT_USER_FEED_COUNT: "DECREMENT_USER_FEED_COUNT",
    UPDATE_FEED: "UPDATE_FEED",
    FETCH_FEED: "FETCH_FEED",
    POST_FEED: "POST_FEED",
    LIKE_UNLIKE_FEED: "LIKE_UNLIKE_FEED",
    DELETE_FEED: "DELETE_FEED",
    EDIT_FEED: "EDIT_FEED"
}